import { useEffect, useMemo } from "react";

import Helpers from "commons/helpers";

/**
 * - Android (Samsung): opens Samsung Internet, falling back to the current
 *   browser if it's unavailable.
 * - Android (other): opens the user's default browser.
 * - iOS: opens Safari via the `x-safari-` scheme.
 */
const openInNativeBrowser = () => {
    const { protocol, host, pathname, search, href } = window.location;
    const ua = navigator.userAgent;

    const isAndroid = /Android/i.test(ua);
    const isIOS = /iPhone|iPad|iPod/i.test(ua);
    const isSamsung = /SamsungBrowser|SAMSUNG|SM-[A-Z0-9]+/i.test(ua);

    if (isAndroid) {
        const scheme = protocol.replace(":", "");
        const path = `${host}${pathname}${search}`;
        const fallback = encodeURIComponent(href);

        // On Samsung devices, target Samsung Internet explicitly.
        // On everything else, omit `package` so the default browser opens.
        const pkg = isSamsung ? "package=com.sec.android.app.sbrowser;" : "";

        window.location.href =
            `intent://${path}#Intent;` +
            `scheme=${scheme};` +
            `action=android.intent.action.VIEW;` +
            `category=android.intent.category.BROWSABLE;` +
            `${pkg}` +
            `S.browser_fallback_url=${fallback};` +
            `end`;
    } else if (isIOS) {
        window.location.href = `x-safari-${href}`;
    } else {
        window.open(href, "_blank");
    }
};

/**
 * Automatically redirects users from Zalo's in-app browser
 * to the native browser (Safari/Chrome).
 */
const ZaloBrowserRedirect = () => {
    const isZalo = useMemo(() => Helpers.isZalo(), []);

    useEffect(() => {
        if (isZalo) {
            openInNativeBrowser();
        }
    }, [isZalo]);

    return <></>;
};

export default ZaloBrowserRedirect;
